const state = {
  list: [],
  isLoading: false,
  invoiceslist: [],
  indentslist: [],
  isUploading: false,
  hasEmpty: false,
  filter: {},
  tempCharges: {},
  indentDetails: [],
  invoiceDetails: [],
  totalSystemCharges: 0,
  totalTransporterCharges: 0,
  transporterTotalFreightCharge: 0,
  freightBillDetails: null,
  isDedicatedTruck: null,
  depotWiseDetails: {},
  isAttachmentAvailable: false,
  isBaseFreightLoading: false,
  indentCharges: null,
  isShipperChargesFeatureEnabled: false,
};

export default state;
